module.exports = __webpack_public_path__ + "img/66.f002bcec.jpg";